// extracted by mini-css-extract-plugin
export var background = "bm_x";
export var backgroundContainer = "bm_fj";
export var buttons = "bm_cD";
export var container = "bm_b";
export var middleWave = "bm_cS";
export var section = "bm_d";
export var text = "bm_b6";
export var textContainer = "bm_cq";
export var title = "bm_h";